import { customElement } from "lit/decorators.js";
import { PrimariaShell } from "./primaria-shell/primaria-shell";
import { PrimariaErrorView } from "./error-view/component";
import { QuickActionsMenu } from "./quick-actions-menu/quick-actions-menu";
import { PrimariaShellHeader } from "./primaria-shell/shell-header/shell-header";
import { PocEventsEcap } from "./poc-events-ecap/poc-events-ecap";
import { PrimariaAccordion } from "./primaria-accordion/primaria-accordion";
import { CommunicationActionMenu } from "./communication-action-menu/communication-action-menu";
import { ClinicalPathwaysActionMenu } from "./clinical-pathways-action-menu/clinical-pathways-action-menu";
import { PetitionerActionMenu } from "./petitioner-action-menu/petitioner-action-menu";
import { HeaderDivider } from "./primaria-shell/shell-header/header-divider/header-divider";

export const useComponents = () => {
  //@ts-ignore
  customElement("primaria-shell")(PrimariaShell);
  //@ts-ignore
  customElement("primaria-shell-header")(PrimariaShellHeader);
  customElement("primaria-error-view")(PrimariaErrorView);
  customElement("quick-actions-menu")(QuickActionsMenu);
  customElement('header-divider')(HeaderDivider);
  //@ts-ignore
  customElement("communication-action-menu")(CommunicationActionMenu);
  //@ts-ignore
  customElement("clinical-pathways-action-menu")(ClinicalPathwaysActionMenu);
  //@ts-ignore
  customElement("petitioner-action-menu")(PetitionerActionMenu);
  //@ts-ignore
  customElement("poc-events-ecap")(PocEventsEcap);
  customElement("primaria-accordion")(PrimariaAccordion);
};
